
export default (arr) => {
  let html
  if (Array.isArray(arr) && arr.length > 0) {
    html = '<ul>'
    html += arr.map(x => {
      return '<li>' + x + '</li>'
    })
    html += '</ul>'
  }
  return html || arr
}
